import { writable } from 'svelte/store';
//replacement for import. Needed for making bundles for old tlmd implementation
const _browser = typeof window !== 'undefined';
export const timeZone = writable(_browser ? Intl.DateTimeFormat().resolvedOptions().timeZone : "Europe/London");
export const locale = writable(_browser ? navigator.language : "en-UK");
const now = new Date();
export const timeRange = writable({ start: new Date(now.getTime()), end: new Date(now.getTime()) });
